import { createAsyncThunk } from '@reduxjs/toolkit';

import { AccountService } from 'api';

export const getDocuments = createAsyncThunk('overview/getDocuments', async () => {
	return await AccountService.getDocuments();
});
